import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      marginBottom: theme.spacing(1.75),
      '&::after': {
        content: '""',
        clear: 'both',
        display: 'block',
      },
    },
    heading: {
      color: '#05A4D8',
      fontSize: '15px',
      fontWeight: 'bold',
      float: 'left',
      display: 'flex',
    },
    actions: {
      float: 'right',
    },
    instructionButton: {
      margin: theme.spacing(-0.75, 0),
    },
  };
};
